module.exports = "/_next/static/images/game-1-phone-attachment-cake-uv-5a57f31137f2db7e3d8afbe9cab3f87d.jpg";